<div class="delta-hedges-container">
  <ag-grid-angular
    class="ag-theme-balham-dark delta-hedges-container__ag-grid"
    [columnDefs]="$any(columnDefs)"
    [sideBar]="sideBarDef"
    (gridReady)="onGridReady($event)"
  >
  </ag-grid-angular>
  <div class="delta-hedges-container__footer" [formGroup]="deltaHedgesForm">
    <div class="delta-hedges-container__footer__date">
      <span class="delta-hedges-container__footer__date__label">
        From Date:
      </span>
      <date-with-spinner-info
        formControlName="fromDate"
        (inputChange)="onDateChange()"
        [inputValidator]="['prettyDate']"
      >
      </date-with-spinner-info>
    </div>

    <div class="delta-hedges-container__footer__time">
      <div class="delta-hedges-container__footer__time__fragment">
        <span class="delta-hedges-container__footer__time__fragment__label">
          From Time:
        </span>
        <app-selector
          [isSearch]="true"
          [passedItems]="hoursArray"
          formControlName="fromHour"
        >
        </app-selector>
      </div>
      <span class="delta-hedges-container__footer__time__separator"> : </span>
      <div class="delta-hedges-container__footer__time__fragment">
        <app-selector
          [isSearch]="true"
          [passedItems]="minutesArray"
          formControlName="fromMinute"
        >
        </app-selector>
      </div>
    </div>
    <app-selector
      class="delta-hedges-container__footer__timezone"
      [isSearch]="true"
      [passedItems]="timezones"
      placeholder="Timezone"
      formControlName="timezone"
    ></app-selector>
  </div>
</div>
